import { Layouts } from 'app-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import NavBarContainer from '../../../containers/common/NavBarContainer';
import AboutAddMember from './AboutAddMember';
import AddMemberFormContainer from './AddMemberFormContainer';

const AddConsumerContainer = styled.div`
    padding: 10px;
`;

const StyledHeader = styled.h1`
    padding-top: 20px;
    padding-bottom: 32px;
`;

const FlexContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Sidebar = styled.aside`
    border: 1px solid #dddde5;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgba(175, 175, 193, 0.16);
    flex: 0 0 20%;
    max-height: fit-content;
    @media (max-width: 768px) {
        flex: 1 1 100%;
    }
`;

const RightPanel = styled.div`
    border: 1px solid #dddde5;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgba(175, 175, 193, 0.16);
    overflow: visible !important;
    flex: 1;
    margin-left: 15px;
    @media (max-width: 768px) {
        flex: 1 1 100%;
        margin-left: 0px;
    }
`;

const AddMemberContainer: React.FC = props => {
    return (
        <Layouts id="add-member">
            <Layouts.Row hasGap={true}>
                <div className="grid-col-12">
                    <div className="grid-row">
                        <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" houseIcon={true} />
                    </div>
                </div>
                <div className="desktop:grid-col-12" id="main-content">
                    <AddConsumerContainer id="addConsumer" data-testid={'addConsumer'}>
                        <StyledHeader>
                            <FormattedMessage id="member.add_member.header" />
                        </StyledHeader>
                        <FlexContainer>
                            <Sidebar id="sidebar" data-testid="sidebar">
                                <AboutAddMember />
                            </Sidebar>
                            <RightPanel id="rightpanel" data-testid="rightpanel">
                                <AddMemberFormContainer />
                            </RightPanel>
                        </FlexContainer>
                    </AddConsumerContainer>
                </div>
            </Layouts.Row>
        </Layouts>
    );
};

export default AddMemberContainer;
